import Store from '@ember-data/store';
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import CachedDataset from 'donor-elf-web/services/cached-dataset';
import NavbarSettingsService from 'donor-elf-web/services/navbar-settings';
import { type FundGroupRouteModel } from '../fund-group';

export default class FundGroupShowRoute extends Route {
  @service declare cachedDataset: CachedDataset;
  @service declare currentUser: any;
  @service declare navbarSettings: NavbarSettingsService;
  @service declare store: Store;

  async model() {
    const fundGroupModel = this.modelFor(
      'admin.fund-groups.fund-group',
    ) as FundGroupRouteModel;

    if (fundGroupModel.fundGroup) {
      this.navbarSettings.title = fundGroupModel.fundGroup.name!;
    } else {
      this.navbarSettings.title = 'Add Fund Group';
    }

    const allUsers = await this.cachedDataset.forModel('admin/user').load();
    const allFunds = await this.cachedDataset.forModel('admin/fund').load();

    const users = (fundGroupModel.fundGroup?.userIds || []).map((userId) =>
      allUsers.find((x) => x.id === userId.toString()),
    );

    const funds = (fundGroupModel.fundGroup?.fundIds || []).map((fundId) =>
      allFunds.find((x) => x.id === fundId.toString()),
    );

    return {
      fundGroup: fundGroupModel.fundGroup,
      users,
      funds,
    };
  }
}
